import { render, staticRenderFns } from "./SidebarMainButton.vue?vue&type=template&id=20ca8211&scoped=true&"
import script from "./SidebarMainButton.vue?vue&type=script&lang=js&"
export * from "./SidebarMainButton.vue?vue&type=script&lang=js&"
import style0 from "./SidebarMainButton.vue?vue&type=style&index=0&id=20ca8211&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ca8211",
  null
  
)

export default component.exports